import script from "./addIntegralProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./addIntegralProducts.vue?vue&type=script&setup=true&lang=js"

import "./addIntegralProducts.vue?vue&type=style&index=0&id=d3fec3de&lang=scss"

const __exports__ = script;

export default __exports__